<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-form-group label="Filtrar por nome ou status">
          <b-form-input v-model="filter" placeholder="Pesquisar..." size="sm" />
        </b-form-group>
      </b-col>
      <b-col class="text-right align-self-end">
        <b-button variant="success" size="sm" @click="addParticipante">
          <feather-icon icon="UserPlusIcon" class="mr-50" />
          Inscrever Pessoa
        </b-button>
      </b-col>
    </b-row>

    <b-table :items="participantes" :fields="fields" responsive show-empty :filter="filter">
      <template #cell(status)="data">
        <b-badge :variant="getStatusVariant(data.value)">
          {{ data.value }}
        </b-badge>
      </template>
      <template #cell(financeiro)="data">
        <div v-if="data.item.fatura" class="d-flex align-items-center">
          <feather-icon icon="DollarSignIcon" :class="data.item.status === 'CONFIRMADO' ? 'text-success' : 'text-warning'" />
          <small class="ml-25">#{{ data.item.fatura }}</small>
        </div>
        <small v-else class="text-muted">Sem cobrança</small>
      </template>
      <template #cell(acoes)="data">
        <b-button variant="flat-danger" size="sm" @click="cancelarInscricao(data.item.id)">
          <feather-icon icon="UserXIcon" />
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BRow, BCol, BTable, BBadge, BButton, BFormInput, BFormGroup } from 'bootstrap-vue'

export default {
  components: { BRow, BCol, BTable, BBadge, BButton, BFormInput, BFormGroup },
  props: ['eventoId'],
  data() {
    return {
      filter: '',
      participantes: [], // Carregar via API
      fields: [
        { key: 'registro.nome', label: 'Participante', sortable: true },
        { key: 'status', label: 'Status' },
        { key: 'financeiro', label: 'Financ.' },
        { key: 'inscritoEm', label: 'Inscrição', formatter: v => v ? new Date(v).toLocaleDateString() : '' },
        { key: 'acoes', label: 'Ações' }
      ]
    }
  },
  methods: {
    getStatusVariant(s) {
      const maps = {
        'INSCRITO': 'light-primary',
        'CONFIRMADO': 'light-success',
        'CANCELADO': 'light-danger',
        'PENDENTE': 'light-warning'
      }
      return maps[s] || 'light-secondary'
    },
    addParticipante() {
      // Abrir modal de busca de registros
    },
    async cancelarInscricao(id) {
      // Chamar API de cancelamento
    }
  }
}
</script>
